import React, { useEffect } from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Aos from "aos";
import "aos/dist/aos.css";
import { makeStyles } from "@material-ui/core/styles";
import NavBar from "../Components/NavBar/NavBar";

import ContactUs from "./ContactUs";
import SocialHeadings from "../Components/SocialHeadings";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function Membership() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
      <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        <NavBar />
      </header>
      <div className="SoleraBody4">
        <div className="SoleraBody">
          <div className="container LandingCont landing-page-container">
            <div className="LandingWrapper">
              <div className="LandingContainer">
                <div className="LandingCoverUp">
                  <div className="LandingHedings1" data-aos="zoom-in-up">
                    Membership
                  </div>

                  <p className="SoleraIntro3030">
                    Calling all University of Lagos graduates! GREAT
                    AKIKOITIES!!!!!!!!!!!!!!! Welcome home, fellow alumni!
                    Whether you proudly bear the title of an "ex-Akokite" or an
                    "Idiarabite," you are already a cherished member of our
                    community. Join our vibrant alumni society to deepen your
                    connection to your alma mater. By becoming an official
                    member with annual dues, you enable us to better serve you,
                    your family, and your business interests. We're here to
                    support you in times of need, whether it's welfare
                    assistance during tough times, celebrating life's
                    milestones, or providing valuable business and career
                    opportunities. But it's not all about business and support;
                    we also know how to have a blast! Our annual get-togethers
                    are a riot of fun and camaraderie, where the focus is on
                    creating lasting memories. You should have seen the energy
                    between Mareire boys vs Moremi girls last time !!!!!! Ready
                    to reconnect, network, and share in the bonds of nostalgia
                    with your fellow alumni? Join us today by clicking the link
                    below. Together, we'll make our alumni community stronger
                    and more vibrant than ever before!
                  </p>
                </div>
                <div className="DemoRequest">{/* <DemoBtn /> */}</div>
              </div>
              <div className="LandImg02">
                <div className="container-fluid p-0">
                  <div className="row g-2">
                    <div className="col">
                      <div className="Landing-Sites">
                        <div className="Landing-Cont-Wrapper">
                          <img
                            src="/assets/solera/ab1.jpeg"
                            alt=""
                            className="Landing-Cont-Wrapperimg "
                          />
                        </div>
                      </div>
                    </div>
                   
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       

        <div className="container VidionAndMissionCont3">
          <div className="row g-2">
            <div className="col-md-6">
              <div className="WhyJoinHeader ">
                <div className="WhyJoinHeaderT"> Member</div>
                <div className="BenefitsNote">
                  The features and benefits of these contributions to members
                  and good name of the alumni association in the UK include:
                </div>
              </div>

              <div className="WhyNoteCover">
                <div className="MembershipAmount">
                  <div className="MembershipAmountDisplay">&#163;10</div>
                  <div className="MembershipJoinNote">
                    Starting from as little as £10 per month
                  </div>
                </div>

                <div className="Membershipbenefits">
                  <ul>
                    <li> Membership cards</li>
                    <li>
                      Costs of holding alumni meetings, conventions and Annual
                      General Meetings (AGMs)
                    </li>
                    <li>
                      {" "}
                      Seeking elective offices within the association in the UK
                      and in Nigeria
                    </li>
                    <li>
                      Voting/delegate rights in the event of an election in the
                      UK and in Nigeria
                    </li>
                    <li>
                      Funding of UK specific programmes for our alma mater and
                      some of its students who may be struggling financially.
                    </li>
                    <li>
                      Souvenirs such as lapel pins, mufflers, ties, scarves,
                      mugs, hooded top, hats, etc for members at discounted
                      prices
                    </li>
                    <li>
                      Financial empowerment: Benefits from organised
                      contributions/support from fellow members when it is
                      needed especially, for members in dire need
                    </li>

                    <li>
                      Access to annual networking events/conventions organised
                      by the association in the UK.
                    </li>
                    <li>
                      Benefits to UK members’ families as agreed to by all e.g.
                      members’ children holiday trips
                    </li>
                    <li>
                      Access to online portal of alumni directory which will
                      contain detailed professional contacts that will
                      facilitate connections to assist every member in there
                      various daily/business endeavours
                    </li>
                    <li>
                      Unlimited access to view online advertisements and equally
                      post on the website i.e. exclusive job adverts, webinars,
                      networking events and online marketing videos, etc
                    </li>
                    <li>
                      Access to provision of life long professional emails (for
                      executive officers only) with UNILAG Alumni UK domain name
                      as against the generic one
                    </li>
                  </ul>
                </div>
                <div className="MembershipJoinNote">
                  One-off minimum project contribution is £25, please feel free
                  to donate more.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="WhyJoinHeader">
                <div className="WhyJoinHeaderT"> Business</div>
                <div className="BenefitsNote">
                  The features and benefits of these contributions to members
                  and good name of the alumni association in the UK include:
                </div>
              </div>
              <div className="WhyNoteCover">
                <div className="MembershipAmount">
                  <div className="MembershipAmountDisplay">&#163;500</div>
                  <div className="MembershipJoinNote">
                    Starting from as little as £500 Yearly
                  </div>
                </div>

                <div className="Membershipbenefits">
                  <ul>
                    <li> Membership cards</li>
                    <li>
                      Costs of holding alumni meetings, conventions and Annual
                      General Meetings (AGMs)
                    </li>
                    <li>
                      {" "}
                      Seeking elective offices within the association in the UK
                      and in Nigeria
                    </li>
                    <li>
                      Voting/delegate rights in the event of an election in the
                      UK and in Nigeria
                    </li>
                    <li>
                      Funding of UK specific programmes for our alma mater and
                      some of its students who may be struggling financially.
                    </li>
                    <li>
                      Souvenirs such as lapel pins, mufflers, ties, scarves,
                      mugs, hooded top, hats, etc for members at discounted
                      prices
                    </li>
                    <li>
                      Financial empowerment: Benefits from organised
                      contributions/support from fellow members when it is
                      needed especially, for members in dire need
                    </li>

                    <li>
                      Access to annual networking events/conventions organised
                      by the association in the UK.
                    </li>
                    <li>
                      Benefits to UK members’ families as agreed to by all e.g.
                      members’ children holiday trips
                    </li>
                    <li>
                      Access to online portal of alumni directory which will
                      contain detailed professional contacts that will
                      facilitate connections to assist every member in there
                      various daily/business endeavours
                    </li>
                    <li>
                      Unlimited access to view online advertisements and equally
                      post on the website i.e. exclusive job adverts, webinars,
                      networking events and online marketing videos, etc
                    </li>
                    <li>
                      Access to provision of life long professional emails (for
                      executive officers only) with UNILAG Alumni UK domain name
                      as against the generic one
                    </li>
                  </ul>
                </div>
                <div className="MembershipJoinNote">
                  One-off minimum project contribution is £25, please feel free
                  to donate more.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container VidionAndMissionCont2">
          <div className="row g-2">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="MakeEnquiry2">Membership form</div>
              <div className="TittleNote">
                Fill up this form to join and make payment.
              </div>
              <div className="TittleNote1">
                Members are directed to pay a registration fee.
              </div>

              <div>
                <div className="TittleNote">
                  Payment Info Name: UNILAG ALUMNI UK <br />
                  Account Type: Business <br />
                  Account Number: 35113029 <br />
                  Sort Code: 23-05-80 IBAN: <br />
                  GB18MYMB 230580 35113029
                </div>
              </div>

              <div>
                <div>
                  <div className="container-fluid p-0">
                    <div className="row gx-4">
                      <div className="col-lg ">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Last Name"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control type="text" placeholder="Last Name" />
                        </FloatingLabel>
                      </div>
                      <div className="col-lg">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Other Names"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            type="`text`"
                            placeholder="Other Names"
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid p-0">
                    <div className="row gx-4">
                      <div className="col-lg ">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Email"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control type="text" placeholder="Last Name" />
                        </FloatingLabel>
                      </div>
                      <div className="col-lg">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Phone number"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            type="`number`"
                            placeholder="Other Names"
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>

                  <FloatingLabel
                    controlId="PhoneNumber"
                    label="City"
                    className="mb-3 Input__User34"
                  >
                    <Form.Control type="text" placeholder="City" />
                  </FloatingLabel>

                  <div className="MoreInfoContainer">
                    <div className="AddInfoHeader">School Information</div>
                    <div className="AddInfo">
                      To confirm you graduated from University of Lagos State,
                      We require you to provide additional information.
                    </div>
                  </div>

                  <div className="container-fluid p-0">
                    <div className="row gx-4">
                      <div className="col-lg ">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Name Of Faculty"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Year Of Graduation"
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-lg">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Name Of Department"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            type="`number`"
                            placeholder="Other Names"
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-lg">
                        <FloatingLabel
                          controlId="floatingUsername"
                          label="Name Of Department"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            type="`number`"
                            placeholder="Other Names"
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>

                  <div className="container-fluid p-0">
                    <div className="row gx-4">
                      <div className="col-lg ">
                        <FloatingLabel
                          controlId="floatingTextarea2"
                          label="Name of course mates not more than 5 names"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            as="textarea"
                            placeholder="Why do you want to join us?"
                            style={{ height: "200px" }}
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-lg">
                        <FloatingLabel
                          controlId="floatingTextarea2"
                          label="Why do you want to join us?"
                          className="mb-3 Input__User34"
                        >
                          <Form.Control
                            as="textarea"
                            placeholder="Why do you want to join us?"
                            style={{ height: "200px" }}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>

                  <button className="SenBtn2">Update Details</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Photo Gallery">
        <ContactUs />
      </div>
    </div>
  );
}

export default Membership;
